var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1947 3.90723H6.47848C5.06059 3.90723 3.90649 5.06653 3.90649 6.49083H14.7686C14.7686 5.06653 13.6145 3.90723 12.1966 3.90723H12.1947ZM3.90649 7.64039V9.93758C3.90649 11.3619 5.06059 12.5212 6.47848 12.5212H12.1947C13.6125 12.5212 14.7666 11.3619 14.7666 9.93758V7.64039H3.90649ZM8.19508 10.5124H6.48042C6.1662 10.5124 5.90822 10.2532 5.90822 9.93758C5.90822 9.62193 6.1662 9.36279 6.48042 9.36279H8.19508C8.5093 9.36279 8.76728 9.62193 8.76728 9.93758C8.76728 10.2532 8.5093 10.5124 8.19508 10.5124Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73846 0.676758H8.34908C9.89675 0.676758 11.2442 1.54938 11.9297 2.83085H10.8584C10.2805 2.07302 9.37068 1.58349 8.34908 1.58349H4.73846C2.99634 1.58349 1.57917 3.00706 1.57917 4.75705V13.8244C1.57917 15.5744 2.99634 16.9979 4.73846 16.9979H8.34908C10.0912 16.9979 11.5084 15.5744 11.5084 13.8244V13.5983H12.411V13.8244C12.411 16.0753 10.5899 17.9047 8.34908 17.9047H4.73846C2.49762 17.9047 0.676514 16.0753 0.676514 13.8244V4.75705C0.676514 2.50609 2.49762 0.676758 4.73846 0.676758ZM7.44643 15.1845C7.69691 15.1845 7.89776 14.9827 7.89776 14.7311C7.89776 14.4795 7.69691 14.2777 7.44643 14.2777H5.64112C5.39063 14.2777 5.18979 14.4795 5.18979 14.7311C5.18979 14.9827 5.39063 15.1845 5.64112 15.1845H7.44643Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualCard);
export default __webpack_public_path__ + "static/media/virtual-card.a9bbb75c4015f98008222feffee86bc9.svg";
export { ForwardRef as ReactComponent };